import {Button, Grid, Paper, TextField, Typography} from "@mui/material";
import * as React from "react";
import AddIcon from "@mui/icons-material/Add";

export class EndSeason extends React.Component<any, any> {
    constructor(props) {
        super(props);

        this.state = {
            top100: []
        }
    }

    addNewTop100() {
        const top100 = this.state.top100;
        top100.push("");
        this.setState({
            top100
        });
    }

    onTop100Change(index, value) {
        const top100 = this.state.top100;
        top100[index] = value;
        this.setState({
            top100
        });
    }

    onSubmit() {
        const top100 = this.state.top100;
        const top100Filtered = top100.filter((item) => item !== "");

        this.props.createTask({
            top100: top100Filtered,
            title: this.props.form.getFieldValue("title"),
            message: this.props.form.getFieldValue("body"),
            receiverIds: this.props.form.getFieldValue("receiverIds")?.split(",")?.map(id => id.trim())?.filter(id => !!id) || [],
            type: this.props.form.getFieldValue("receiver_type"),
            receiverStore: this.props.form.getFieldValue("receiver_store")
        });
    }

    render() {
        return (
            <Paper>
                <Typography variant="h3">Top 100</Typography>
                <Grid container>
                    <Grid item container xs={12} justifyContent={"flex-end"} spacing={2}>
                        <Grid item>
                            <Button
                                color="primary"
                                size="small"
                                variant="contained"
                                onClick={() => this.addNewTop100()}
                            >
                                <AddIcon />
                                Add Top100
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button
                                color="primary"
                                size="small"
                                variant="contained"
                                onClick={() => this.onSubmit()}
                            >
                                Submit
                            </Button>
                        </Grid>

                        {
                            this.state.top100.map((item, index) => (
                                <Grid item xs={12}>
                                    <TextField
                                        label={`Top ${index + 1}`}
                                        fullWidth value={item}
                                        onChange={(e) => this.onTop100Change(index, e.target.value)}
                                    />
                                </Grid>
                            ))
                        }

                    </Grid>
                </Grid>

            </Paper>
        );
    }
}